import { getOwnerDocument } from "./getOwnerDocument";
export { getOwnerDocument };
export default getOwnerDocument;
